function createAnalytics(googleAnalyticsId) {
  if (!googleAnalyticsId || process.env.APP_ENV !== 'production' || typeof window === 'undefined') {
    return;
  }

  window.GoogleAnalyticsObject = 'ga';
  window.ga = window.ga || ((...args) => {
    window.ga.q = (window.ga.q || []).concat(args);
  });
  window.ga.l = Date.now();

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.google-analytics.com/analytics.js';
  document.body.appendChild(script);

  window.ga('create', googleAnalyticsId, 'auto');
  window.ga('send', 'pageview');
}

export default createAnalytics;
